import React, { useCallback, useEffect, useState } from 'react';

import Waveform from './waveform';
import { useClipsState } from './clips/state';
import { Clip } from '../../../../../shared/types/clips';

interface Props {
  clip: Clip;
  idx: number;
  currentTime: number;
  onClick: (
    event: React.MouseEvent,
    { secs, clipIdx }: { secs: number; clipIdx: number }
  ) => void;
}

const ClipEditor = ({
  clip,
  idx,
  currentTime,
  onClick,
}: Props): JSX.Element => {
  const { waveform_url: waveformUrl } = clip;

  const [waveformData, setWaveformData] = useState([]);

  const { focusedClipIndex, focusedPlayRangeIndex, updatePlayRange } =
    useClipsState(
      useCallback(
        state => ({
          focusedClipIndex: state.focusedClipIndex,
          focusedPlayRangeIndex: state.focusedPlayRangeIndex,
          updatePlayRange: state.updatePlayRangeForClip(idx),
        }),
        [idx]
      )
    );

  const getWaveformJSON = useCallback(async () => {
    // @ts-expect-error ignore due to enabling strict null checks
    const resp = await fetch(waveformUrl);

    if (!resp.ok) {
      throw new Error('Failed to fetch waveform json');
    }

    const data = await resp.json();

    setWaveformData(data);
  }, [waveformUrl]);

  useEffect(() => {
    if (waveformUrl) {
      getWaveformJSON();
    }
  }, [waveformUrl, getWaveformJSON]);

  return (
    <Waveform
      key={clip.id}
      clipId={clip.id}
      viewboxHeight={80}
      peaks={waveformData}
      peakCount={1000}
      isFocusedClip={idx === focusedClipIndex}
      cursorWidth={2}
      cursorVerticalMargin={16}
      cursorPos={currentTime}
      // @ts-expect-error ignore due to enabling strict null checks
      duration={clip.duration}
      normalize={false}
      sectionOutlineWidth={2}
      onClick={onClick}
      // @ts-expect-error ignore due to enabling strict null checks
      playRanges={clip.playRanges}
      selectedPlayRange={focusedPlayRangeIndex}
      updatePlayRange={updatePlayRange}
      waveformStatus={clip.waveform_generation}
      // @ts-expect-error ignore due to enabling strict null checks
      hasAudio={clip.video_properties.microphone_enabled}
    />
  );
};

export default ClipEditor;
